export const usePromise: (result: any) => Promise<any> = (result: any) => {
  if (!result) return Promise.reject()
  return Promise.resolve(result)
}
